module.exports = __webpack_public_path__ + "media/src/assets/Images/NotificationBellOutline-9c4c61616924c05086a0dee8e3b92b31.svg";